// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { useDispatch } from "react-redux";
import {
  fetchInvestorInvitionStatus, getRegisterdInvestors, initialResetState, postInvestorLoginTime, postInvestorUser, resetAll, resetLoginDetails, setLoginUserdetails, SetUserId,
} from "../redux/slice/userSlice";
import {
  fetchAccountData,
  getKycDetails,
  postKycDetails,
} from "../redux/slice/ledgerSlice";
import { clearAllMyBidUpdates, MyBidApi } from "../redux/slice/mybidSlice";
import {
  getAPIMKey,
  getApplicationId,
  getFcltAppUrl,
  getIsWiredTransfer,
  getMSALBaseUrl,
  getSigninPolicy,
  getSignupPolicy,
  getUserApiUrl,
} from "../utils/config";
import { AppDispatch } from "../redux/types";
import { AxiosError } from "axios";
import { fetchToken, handleFetchApi } from "../utils/api"
const handleUnload = (event, logout = false) => {
  try {
    const ImpersonatedToken = sessionStorage.getItem('impersonateToken');
    const fcltToken = sessionStorage.getItem('idtokens');
    if (!ImpersonatedToken || !fcltToken) return;
    const isLocalhost = window.location.hostname === "localhost";
    const portNumber = window.location.port === "3001" ? 3000 : 3001;
    const targetOrigin = isLocalhost
      ? `http://localhost:${portNumber}`
      : getFcltAppUrl();

    const token = { ImpersonatedToken, fcltToken };
    const message = { status: "sessionClosed", logout, token };
    if (window.opener && ImpersonatedToken) {
      window.opener.postMessage(message, targetOrigin);
    } else if (window.parent !== window) {
      window.parent.postMessage(message, targetOrigin);
    } else {
      console.log("No parent or opener to send message to.");
    }
  } catch (error) {
    console.error(error);
  }
};

const ProtectedRoute = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const [kycInProgress, setKycInProgress] = useState(false);
  const navigate = useNavigate();
  const signinAuthority = `${getMSALBaseUrl()}/${getSigninPolicy()}`;
  const signupAuthority = `${getMSALBaseUrl()}/${getSignupPolicy()}`;
  // Parse query params
  const searchParams = new URLSearchParams(location.search);
  const isImpersonate = sessionStorage.getItem("isImpersonate") ?? searchParams.get("isImpersonate");
  const impersonateEmail = searchParams.get("impersonateEmail");
  useEffect(() => {
    if ( sessionStorage.getItem('impersonateEmail') == null && isImpersonate  ) {
       dispatch(clearAllMyBidUpdates());
    }
  }, [isImpersonate]);
  const getAuctionCount = (auctions) => {
    let count = 0;
    count += auctions?.Today?.length || 0;
    count += auctions["Next Week"]?.length || 0;
    count += auctions["Next Month"]?.length || 0;
    count += auctions?.Upcoming?.length || 0;
    return count > 0;
  };
  const handleSignupPolicyRedirect = async (path, user) => {
    const isSignupPolicy = user?.acr === getSignupPolicy().toLowerCase();
    if (isSignupPolicy) {
      await instance.loginRedirect({
        ...loginRequest,
        authority: signinAuthority,
        state: path,
      });
      return true;
    }
    return false;
  };
  const handleNewSignupProcess = async (path, user) => {
    const isSignup = path === "/signup";
    if (isSignup && user) {
      const payload = {
        firstName: user?.given_name,
        lastName: user?.family_name,
        email: user?.email,
        mobile: user?.extension_phoneNumber.replace(/\D/g, ""),
      };
      await dispatch(postInvestorUser(payload));
      return true;
    }
    return false;
  };

  const handleActiveAccountFlow = async (userDetails, investorId, path) => {
    const isWired = getIsWiredTransfer();
    if (!userDetails?.IsTermsConditionsAccepted) {
      navigate("/kyc-kyb/bidding-agreement");
    } else {
      if (isWired === "0") {
        const accountDetails = await dispatch(fetchAccountData(investorId));
        if (!Array.isArray(accountDetails.payload)) {
          navigate("/kyc-kyb/account-verification/add-bank-account");
        } else {
          navigate("/kyc-kyb/account-verification/add-funds");
        }
      } else {
        if (
          path === "/signin" ||
          path === "/signup" ||
          path.includes("kyc-kyb") ||
          path === "/"
        ) {
          if (path === "/kyc-kyb/bidding-agreement") {
            const wiredPath =
              isWired === "1"
                ? "/kyc-kyb/account-verification/add-funds-wired-transfer"
                : "/kyc-kyb/account-verification/add-funds";
            navigate(wiredPath);
          } else {
            const bidResponse = await dispatch(
              MyBidApi(parseInt(investorId))
            ).unwrap();
            const hasAuction = getAuctionCount(bidResponse.data);
            navigate(hasAuction ? "/home" : "/search");
          }
        }
      }
    };


  };
  const handleInactiveAccountFlow = async (userDetails, investorId) => {
    let kycDetails = await dispatch(getKycDetails(investorId)).unwrap();
    const kycAttempts = userDetails?.KycAttempts;
    const kycBody = kycDetails?.body?.[0];
    const { kyc_action, verification_status } = kycBody || {};

    const silaStatusList = [
      userDetails.IsSilaRegistered,
      ...userDetails.BusinessAccounts.map((ele) => ele.IsSilaRegistered)
    ];

    const isSilaRegister = silaStatusList?.every((item) => item === true);
    if (isSilaRegister && kycAttempts === 0 && userDetails?.VerificationStatus === "") {
      const response = await dispatch(postKycDetails(userDetails?.InvestorId)).unwrap();
      if (response.statusCode === 400) {
        navigate("/kyc-kyb/identity-verification", {
          state: { investorId },
        });
        return;
      } else if (response.statusCode === 200) {
        await new Promise(resolve => setTimeout(resolve, 5000));

        // Fetch fresh data before continuing
        try {
          const freshUserDetails = await dispatch(getRegisterdInvestors(userDetails?.email)).unwrap();
          await handleInactiveAccountFlow(freshUserDetails?.response, investorId);
        } catch (error) {
          console.error("Error fetching fresh user details:", error);

        }
        return;
      }
    }
    else if (kycAttempts === 0) {
      navigate("/kyc-kyb/identity-verification", {
        state: { investorId },
      });
      return;
    }

    const kycActionBussiness = userDetails?.KycAction
    const kycActionBussinessAccounts = userDetails?.BusinessAccounts?.map(item => item.KycAction)
    const userHandles = kycDetails?.body[0]?.reasons || {};
    const kycAction = [...kycDetails?.body?.map((ele) => ele.kyc_action), kycActionBussiness, ...kycActionBussinessAccounts];
    const entriesArray = Object.entries(userHandles).map((ele) => ele[0]);
    const hasFailure = kycDetails?.body?.some(
      (item) =>
        ([null].includes(item.verification_status)) &&
        item.kyc_action === null &&
        item.status === "FAILURE"
    );
    let hasDocUpload = kycAction?.some((item) => item === "doc_upload");
    let entityData = kycAction?.every((item) => item === "entity_data" || item === "");
    let hasReview = kycAction?.some((item) => item === "review");
    let hasSilaInprogress = kycAction?.some((item) => item === "inprogress_nonsila");
    const isDocumentsReceivedAccounts = userDetails?.BusinessAccounts?.map(item => item.VerificationStatus)

    const isDocumentsReceived = [userDetails.VerificationStatus, ...isDocumentsReceivedAccounts].some((item) => item === "documents_received");
    const isReviewPending = verification_status === "pending" || verification_status === "";

    if (hasFailure || userDetails.DocumentRequiredFor === "session_identifier" ||
      verification_status === "failed" ||
      verification_status === "member_failed"
    ) {
      navigate("/kyc-kyb/identity-verification/failed");
    }
    else if (hasReview || hasSilaInprogress || verification_status === "review" || isDocumentsReceived) {
      navigate("/kyc-kyb/identity-verification/inprogress");
    }
    else if (isReviewPending || (hasReview)) {
      navigate(
        `/kyc-kyb/identity-verification/${userDetails.UserType}/inprogress-validate`
      );
    } else if (!kycDetails || kycDetails.body?.length === 0) {
      navigate("/kyc-kyb/identity-verification/waiting");
    } else if (
      ["pending", ""].includes(verification_status) ||
      userDetails?.VerificationStatus === "pending"
    ) {
      navigate(
        `/kyc-kyb/identity-verification/${userDetails.UserType}/inprogress-validate`
      );
    } else if (
      (hasDocUpload) &&
      ["documents_required", "member_review"].includes(verification_status)
    ) {
      navigate(
        `/kyc-kyb/identity-verification/${userDetails.UserType}/additional-document`
      );
    }
    else if (
      (kyc_action === "entity_data" || kyc_action === null) &&
      (["documents_required", "member_review"].includes(verification_status) ||
        (kyc_action === null && verification_status === "member_review"))
    ) {
      navigate("/kyc-kyb/identity-verification", {
        state: { investorId },
      });
    }
    else if (
      userDetails.UserType === "individual" &&
      kyc_action === "entity_data" &&
      ["documents_required", "member_review"].includes(verification_status)
    ) {
      navigate("/kyc-kyb/identity-verification", {
        state: { investorId },
      });
    }
    else if (
      kyc_action === "doc_upload"
    ) {
      navigate(
        `/kyc-kyb/identity-verification/${userDetails.UserType}/additional-document`
      );
    } else {
      kycAttempts > 1 ? navigate("/kyc-kyb/identity-verification/inprogress")
        : navigate(`/kyc-kyb/identity-verification/${userDetails.UserType}/inprogress-validate`)

    }

  };

  const handleRegisteredInvestor = async (email, path, user) => {
    const response = await dispatch(getRegisterdInvestors(email)).unwrap();
    if (typeof response?.error === "string" && response?.error) {
      const userId = response.error.split(": ")[1];
      dispatch(SetUserId(Number(userId)));
    }
    const investorId = response?.investorId;
    const userDetails = response?.response;

    localStorage.setItem('updatedInvestorId', investorId)

    if (response?.isEmailRegistered && investorId) {
      dispatch(SetUserId(Number(userDetails?.UserId)));
      dispatch(setLoginUserdetails(userDetails));

      if (userDetails?.AccountStatus === "ACTIVE") {
        await handleActiveAccountFlow(userDetails, investorId, path);
      } else {
        await handleInactiveAccountFlow(userDetails, investorId);
      }

      return true;
    }
    return false;
  };
  const handleUnregisteredEmailCheck = async (email) => {
    try {
      const statusResponse = await dispatch(
        fetchInvestorInvitionStatus({ email })
      ).unwrap();

      if (statusResponse.data.statusCode === 404) {
        navigate("/not-invited");
        return true;
      }
    } catch (error) {
      const status = error?.statusCode;
      if (status === 404) {
        navigate("/not-invited");
        return true;
      } else if (status === 400) {
        console.warn("Bad Request (400)");
      } else {
        console.error("Unexpected error:", error);
      }
    }
    return false;
  };
  // Start fade effect after 3 seconds
  const handleCheckKYC = async (email, path, user) => {
    if (!email) return;
    const isImpersonated = sessionStorage.getItem("isImpersonate")
    setKycInProgress(true);
    dispatch(resetLoginDetails());
    try {

      if (!isImpersonated) {
        const isSignupPolicyHandled = await handleSignupPolicyRedirect(
          path,
          user
        );
        await handleNewSignupProcess(path, user);
        await dispatch(postInvestorLoginTime())
      }
      const isRegistered = await handleRegisteredInvestor(email, path, user);
      if (isRegistered) {
        setLoading(false);
        return;
      }

      const isUnregisteredHandled = await handleUnregisteredEmailCheck(email);
      if (isUnregisteredHandled) {
        setLoading(false);
        return;
      }
      // Email is not registered and invitation status was not 404
      dispatch(initialResetState());
      dispatch(setLoginUserdetails(null));
      navigate("/kyc-kyb/identity-verification", {
        state: { investorId: null },
      });
      setLoading(false);

    } catch (error) {
      console.error("Error checking KYC:", error);
    } finally {
      setKycInProgress(false); // Hide loading indicator
    }
  }

  const handleAuthenticet = async () => {
    const authority =
      pathname !== "/signup" ? signinAuthority : signupAuthority;
    let prompt =
      pathname === "/signup" || pathname === "/signin" ? "select_account" : ""; // Force account selection for signin and signup screen
    instance
      .loginRedirect({
        ...loginRequest,
        authority,
        state: pathname, // Store the current path to redirect after login
        prompt: prompt,
      })
      .catch((error) => console.error("Login error:", error));
  };

  const handleLoginRedirect = async () => {
    if (inProgress !== "handleRedirect") {
      return;
    }
    try {
      const response = await instance.handleRedirectPromise();
      if (response?.account) {
        instance.setActiveAccount(response.account);
        await handleCheckKYC(
          response.account?.idTokenClaims?.email,
          response.state,
          response.account?.idTokenClaims
        );
      }
    } catch (error) {
      console.error("Error handling redirect response:", error);
    }
  };

  const isLocalhost = window.location.hostname === "localhost"
  const portNumber = window.location.port === "3001" ? 3000 : 3001
  const baseUrl = isLocalhost
    ? `http://localhost:${portNumber}`
    : getFcltAppUrl();
  const receiveMessage = async (event) => {
    if (event.origin !== baseUrl) return;
    if (event.data.status && event.data.status === 'logout') {
      await handleFetchApi({
        method: "POST",
        endpoint: "auth/logout",
        baseUrl: getUserApiUrl()
      })
      window.close();
      return
    }
    const { accessToken } = event.data || {};
    if (!accessToken) return;
    if (event.data.status && event.data.status === 'tokenRefresh') {
      sessionStorage.setItem("idtokens", accessToken);
      return
    }

    try {
      sessionStorage.setItem("idtokens", accessToken);
      if (isImpersonate && impersonateEmail) {
        sessionStorage.setItem("isImpersonate", isImpersonate || "false");
        sessionStorage.setItem("impersonationHandled", "true");
        sessionStorage.setItem("impersonateEmail", impersonateEmail || "");
      }
      // const decodedToken1 = jwt_decode.default(accessToken);
      // const decodedToken1 = jwt_decode<{ [key: string]: any }>(accessToken);
      const jwtDecodeModule = await import("jwt-decode");
      const decodeFn = jwtDecodeModule.jwtDecode;
      const decodedToken = decodeFn(accessToken);

      // const decodeFn = (jwt_decode as any).default || jwt_decode;
      // const decodedToken1 = decodeFn(accessToken);

      console.log(`decodedToken: `, decodedToken);

      // const decodedToken = jwt_decode(accessToken);
      console.log("Token decoded successfully");

      console.log(`homeAccountId:`, decodedToken.oid);
      console.log(`tenantId: ${decodedToken.tid}`);
      console.log(`username: ${decodedToken.email}`);
      console.log(`localAccountId: ${decodedToken.sub}`);
      console.log(`idTokenClaims:`, decodedToken);

      const impersonatedAccount = {
        homeAccountId: decodedToken.oid || decodedToken.sub,
        environment: "b2clogin.com",
        tenantId: decodedToken.tid,
        username: decodedToken.email || decodedToken.upn,
        localAccountId: decodedToken.oid || decodedToken.sub,
        idTokenClaims: accessToken,
      };
      const email = impersonateEmail ?? sessionStorage.getItem("impersonateEmail");
      handleCheckKYC(email, pathname, {})
      // instance.setActiveAccount(impersonatedAccount);
      console.log("Impersonated account set.");
    } catch (err) {
      alert(`Error decoding token: ${err}`);
      console.error("Error decoding token", err);
    }
  };



  // Trigger login if the user is not authenticated and fade has occurred
  useEffect(() => {
    if (kycInProgress) {
      return; // if kyc is in progress then return this UseEffect will not work
    }
    setLoading(true);
    // Early return if a redirect is in progress
    if (inProgress !== "none") {
      handleLoginRedirect(); // Handle redirect after login
      return; // Ensure no other logic runs until the redirect handling is complete
    } else if (inProgress === "none") {
      let timeOutId;
      // Check if the user is authenticated
      if (!isAuthenticated || pathname === "/signup" || isImpersonate === "true") {
        if (isImpersonate === "true") {
          // Replace with actual prod URL
          if (window.opener) {
            window.opener.postMessage("readyForToken", baseUrl);
          }
          // Clear localStorage on first-time load
          const [navigation] = performance.getEntriesByType('navigation') || [];
          if (navigation && navigation.type === 'navigate') {
            console.log("Clearing localStorage on first-time load");
            localStorage.clear();
          }
        } else {
          timeOutId = setTimeout(() => {
            handleAuthenticet(); // Trigger authentication flow if not authenticated
          }, 1000);
        }


      } else if (isAuthenticated) {
        // If authenticated and not on signin or signup, allow the page to render
        const activeAccount = instance.getActiveAccount();
        handleCheckKYC(
          activeAccount?.idTokenClaims?.email,
          pathname,
          activeAccount?.idTokenClaims
        );
        //  setLoading(false)
      }
      window.addEventListener("message", receiveMessage); // ✅ Runs only once
      window.addEventListener("beforeunload", (event) => { handleUnload(event, false) })
      return () => {
        clearTimeout(timeOutId);
        window.removeEventListener("beforeunload", (event) => { handleUnload(event, false) });
        window.removeEventListener("message", receiveMessage);
      };
    }
  }, [inProgress, isAuthenticated]);

  // Show splash screen while loading or during redirect handling
  if (loading) {
    return <Loading />;
  }
  // Render children if user is authenticated and not on signup/signin pages
  return (isAuthenticated || isImpersonate === "true") &&
    !loading &&
    pathname !== "/signin" &&
    pathname !== "/signup"
    ? children
    : null;
};

export default ProtectedRoute;
